<template>
    <div class="travel" v-if="apiAccomplish">
        <TransparentHeader :scrollHeight="100" color="#00D7AA" titleColor="#FFFFFF" :titleCustomOpacity="1">
            <div slot="title" class="title-switch-wrap">
                <div class="item-tab travel-tab">
                    同程旅行
                </div>
                <div class="item-tab taxi-tab" @click="gotoTaxi">
                    同程打车
                </div>
            </div>
            <div slot="right-btn">

            </div>
        </TransparentHeader>
        <div class="box-wrap">
            <div class="box-bottom-wrap">
                <div class="coupon-wrap" @click="couponClick">
                    <div class="price-wrap">
                        <span class="symbol">￥</span><span class="price">216</span>
                    </div>
                    <div class="title-wrap">
                        <li class="title">同程旅行出行权益劵包</li>
                        <li class="desc">最多含9张出行优惠券</li>
                    </div>
                    <div class="status">
                        {{couponStatus ==1?'已领取':'未领取'}}
                    </div>
                </div>

                <div>
                    <div class="agreement-wrap">
                        <van-checkbox v-model="agreementChecked" icon-size="16"></van-checkbox>
                        <li class="text"><span class="left-text">我已阅读并同意遵守</span><span
                                @click="privacyClick">《隐私协议》</span>、<span @click="agreementClick">《用户协议》</span></li>
                    </div>
                </div>

                <div v-if="couponStatus==1" @click="jumpMiniProgram" class="btn-wrap">
                    <img class="btn" src="../../../assets/img/202209/travel/btn.png" alt="">
                </div>
                <div class="change-mobile-btn" @click="changeMobileClick">
                    更换手机号领取
                </div>
            </div>
        </div>

        <div class="rule-wrap">
            <li class="title">活动说明</li>
            <p>1、优惠券默认发放的账号为高佣联盟绑定的手机号，请在同程旅行app或者同程旅行小程序登录的手机号和高佣联盟登录的手机号保持一致。</p>
            <p>2、如果手机号不同，请《更换手机号领取》即可。</p>
            <p>3、领取优惠券如何使用：在同程旅行app或者同程旅行小程序下单支付时抵扣使用。 </p>
        </div>

        <van-dialog v-model="changeMobileModelShow" title="" :showConfirmButton="false">
            <div class="dialog-wrap">
                <li class="title">更换手机号领取</li>
                <div>
                    <li class="label">领取手机号</li>
                    <input class="input" type="number" v-model="mobile">
                </div>
                <div class="btn" @click="confirmReceive">
                    确认领取
                </div>
            </div>
            <img class="dialog-close" @click="changeMobileModelShow=false"
                 src="../../../assets/img/202209/travel/close.png" alt="">
        </van-dialog>
    </div>
    <div v-else class="loading-wrap">
        <van-loading>加载中...</van-loading>
    </div>
</template>

<script>
    import {Dialog, Loading, Checkbox, CheckboxGroup} from 'vant';
    import {Usual} from "@/common/mixins/usual";
    import {tongchengSendCoupon} from '../../../api/202209/travel'
    import TransparentHeader from '@/common/components/TransparentHeader'
    import {goodsJump, getPlatform} from '@/common/utils'

    const {isIPhoneX, currentPlatform} = getPlatform();

    export default {
        name: "travelIndex",
        components: {
            TransparentHeader,
            [Dialog.Component.name]: Dialog.Component,
            [Loading.name]: Loading,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
        },
        mixins: [Usual],
        data() {
            return {
                changeMobileModelShow: false,
                couponStatus: 0,//状态：1-已领取，0-未领取(如果返回异常时默认为未领取)
                apiAccomplish: false,
                isLoading: false,
                tabName:'travel',
                mobile: '',
                miniProgram: {
                    path: '/page/home/index/index?wxrefid=2000005195&tab=1&appid=wx336dcaf6a1ecf632',
                    orgId: 'gh_0a00573ff7cf'
                },
                h5Url: 'https://m.ly.com/?refid=1980701627',
                agreementChecked: false,
                privacyIosUrl: 'https://privacy-policy-w.elong.com/privacyApp/link/latest/versionHtml?appkey=4jFJFrN6cNHz&type=0',
                agreementIosUrl: 'https://privacy-policy-w.elong.com/privacyApp/link/latest/versionHtml?appkey=4jFJFrN6cNHz&type=5',
                privacyAndroidUrl: 'https://privacy-policy-w.elong.com/privacyApp/link/latest/versionHtml?appkey=nHySWFTsEXaf&type=0',
                agreementAndroidUrl: 'https://privacy-policy-w.elong.com/privacyApp/link/latest/versionHtml?appkey=nHySWFTsEXaf&type=5',
                taxiCouponStatus:0,
                taxiApiAccomplish: false,
                taxiIsLoading: false,
            }
        },
        created() {
            this.trackEvent('同程旅行发劵主页浏览量');
            this.getTongchengSendCoupon()
        },
        methods: {
            //埋点
            trackEvent(key = "同程旅行") {
                this.$uweb.trackEvent("TCLX", key, currentPlatform);
            },
            //点击更换手机号
            changeMobileClick() {
                this.trackEvent('更换手机按钮点击量');
                this.changeMobileModelShow = true
            },
            //type auto  passivity:会弹出toast
            getTongchengSendCoupon(type = 'auto') {
                if (this.isLoading) {
                    return
                }
                this.isLoading = true
                tongchengSendCoupon({
                    userId: this.userInfo.uid,
                    userType: this.userInfo.utype,
                    mobile: this.mobile
                }).then((res) => {
                    let resData = res.data.data
                    this.couponStatus = resData?.status || 0
                    if (type == 'passivity') {
                        if (this.couponStatus == 1) {
                            this.$toast('领取成功')
                        } else {
                            //一般情况下不会走到这里
                            this.$toast('您的手机号暂不能领取，请更换手机号领取')
                        }
                    }
                }).catch(() => {
                    this.couponStatus = 0
                }).finally(() => {
                    this.apiAccomplish = true
                    this.isLoading = false
                })
            },
            //优惠券领取
            couponClick() {
                this.trackEvent('优惠券按钮点击量');
                if (this.couponStatus == 1) {
                    //成功领取则跳转小程序
                    this.jumpMiniProgram()
                } else {
                    //发起领取请求
                    this.getTongchengSendCoupon('passivity')
                }
            },
            gotoTaxi(){
                this.$router.push({
                    name: "2209Taxi"
                });
            },
            privacyClick() {
                let appurl = ''
                if (this.$GY_platform.isGYApp) {
                    if (this.$GY_platform.isGYiOSApp) {
                        appurl = this.privacyIosUrl
                    } else {
                        appurl = this.privacyAndroidUrl
                    }
                    goodsJump({
                        type: 23,
                        appurl
                    })
                } else {
                    this.$toast('请下载高佣APP')
                }
            },
            agreementClick() {
                let appurl = ''
                if (this.$GY_platform.isGYApp) {
                    if (this.$GY_platform.isGYiOSApp) {
                        appurl = this.agreementIosUrl
                    } else {
                        appurl = this.agreementAndroidUrl
                    }
                    goodsJump({
                        type: 23,
                        appurl
                    })
                } else {
                    this.$toast('请下载高佣APP')
                }
            },
            //去下单,type=1跳转小程序 type=2跳转H5
            jumpMiniProgram() {

                if(!this.agreementChecked){
                    this.$toast('请阅读并同意协议')
                    return
                }

                this.trackEvent('去下单按钮点击量');
                if (this.$GY_platform.isGYApp) {
                    let type = this.$route.query?.type || 2
                    let opt = ''
                    if (type == 2) {
                        opt = {
                            type: 23,
                            appurl: this.h5Url
                        }
                    } else {
                        opt = {
                            type: 35,
                            appurl: this.miniProgram.path,
                            orgId: this.miniProgram.orgId
                        }
                    }
                    goodsJump(opt)
                } else {
                    this.$toast('请下载高佣APP')
                }
            },
            //确认领取按钮
            confirmReceive() {
                if (!/^\d{11}$/.test(this.mobile)) {
                    this.$toast('请输入正确手机号')
                    return
                }
                this.changeMobileModelShow = false
                this.getTongchengSendCoupon('passivity')
            }
        }
    }
</script>

<style lang="less" scoped>
    .title-switch-wrap {
        width: 420px;
        height: 72px;
        background: rgba(255,255,255,.2);
        border-radius: 36px;
        display: flex;
        color: #FEFEFE;
        align-items: center;
        padding: 8px;
        .travel-tab {
            width: 202px;
            height: 56px;
            background: #fff;
            border-radius: 28px;
            color: #00C99F;
        }
        .item-tab {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 34px;
            font-weight: normal;
        }
    }
    .travel {
        background: url("../../../assets/img/202209/travel/ls/banner02.png") #0369FF no-repeat;
        background-size: 100%;
        min-height: 100vh;
        padding-top: 750px;
        padding-bottom: 10px;

        li {
            list-style: none;
        }

        .box-wrap {
            background: url("../../../assets/img/202209/travel/box_bg_1.png") no-repeat;
            background-size: 100%;

            width: 686px;
            margin: 0 auto;
            padding-top: 103px;

            .box-bottom-wrap {
                background-image: linear-gradient(to bottom, #dbedff, #fff);
                border-bottom-left-radius: 30px;
                border-bottom-right-radius: 30px;

                padding: 0 24px 32px;
            }

            .coupon-wrap {
                width: 638px;
                height: 158px;
                background: url("../../../assets/img/202209/travel/coupon.png") no-repeat;
                background-size: 100%;
                padding: 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .price-wrap {
                    color: #FE4617;
                    width: 128px;
                    text-align: center;

                    .symbol {
                        font-size: 20px;
                    }

                    .price {
                        font-size: 50px;
                    }
                }

                .title-wrap {
                    color: #FE4617;
                    width: 302px;

                    .title {
                        font-size: 28px;
                        font-weight: 700;
                    }

                    .desc {
                        font-size: 22px;
                    }
                }

                .status {
                    width: 148px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #FEE76B;
                    text-align: center;
                }

            }

            .btn-wrap {
                margin-top: 32px;
            }

            .btn {
                width: 646px;
                height: 80px;

            }

            .change-mobile-btn {
                font-size: 28px;
                font-weight: 500;
                color: #FE4617;
                margin-top: 32px;
                text-align: center;
            }
        }

        .rule-wrap {
            width: 686px;
            background: rgba(255, 255, 255, .2);
            border-radius: 20px;
            margin: 30px auto;
            padding: 30px 24px;
            color: #fff;
            line-height: 36px;
            font-size: 24px;

            .title {
                font-size: 32px;
                font-weight: 800;
                color: #fff;
                margin-bottom: 32px;
                text-align: center;

            }
        }

        .dialog-wrap {
            width: 580px;
            background: #fff;
            border-radius: 40px;
            padding: 40px 40px 56px;

            .title {
                font-size: 34px;
                font-weight: 700;
                color: #1A1A1A;
                text-align: center;
            }

            .label {
                font-size: 24px;
                font-weight: 400;
                color: #808080;
                margin-top: 64px;
            }

            .input {
                width: 500px;
                height: 84px;
                background: #F5F5F5;
                border-radius: 20px;
                font-size: 32px;
                font-weight: 600;
                color: #1A1A1A;
                margin-top: 24px;
                padding: 30px;
            }

            .btn {
                width: 340px;
                height: 76px;
                background: #00D7AA;
                border-radius: 38px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 56px auto 0;
            }
        }

        .dialog-close {
            width: 54px;
            position: relative;
            left: 50%;
            margin-top: 100px;
            transform: translate(-50%);
        }

        /deep/ .van-dialog {
            background: transparent;
            width: auto
        }
    }

    .loading-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
    }

    .agreement-wrap {
        display: flex;
        margin-top: 32px;
        align-items: center;

        .text {
            color: #158EFF;
            margin-left: 5px;
        }

        .left-text {
            color: #808080;
        }
    }
</style>
